import { getRevenda } from '../../config/auth'
import { Collection, WhereField } from '../../shared/constants'
import { chunkItemsByQuantity } from '../../shared/utils'
import { addDoc, deleteDoc, getAllDocsByClientId, getAllDocsByParkId, getAllDocsByQueries, getDocById, updateDoc } from './collectionBaseWorker'
import { where } from "firebase/firestore"

export const addProduct = async ({ clienteId,
    estacionamentoId,
    descricao,
    valor,
    valorCusto,
    margemLucro,
    tipoProduto,
    createdBy,
    revendaId }) => {
    const data = {
        clienteId: clienteId,
        estacionamentoId: estacionamentoId,
        revendaId: revendaId ?? getRevenda()?.id,
        createdAt: new Date(),
        createdBy: createdBy,
        descricao: descricao,
        tipoProduto: tipoProduto,
        valor: valor,
        valorCusto: valorCusto,
        margemLucro: margemLucro,
        isDeleted: false,
    }
    const doc = await addDoc({ collection: Collection.PRODUCT, data: data })
    return doc.id;
}

export const getProductById = async ({ id }) => {
    return await getDocById({ collection: Collection.PRODUCT, id: id })
}

export const getAllProductsByClientId = async ({ clienteId }) => {
    return await getAllDocsByClientId({ collection: Collection.PRODUCT, clienteId: clienteId })
}

//Não usar
export const getAllProducts = async ({ parkId }) => {
    const items = await getAllDocsByQueries({
        collection: Collection.PRODUCT,
        queries: [
            where(WhereField.PARKID, "==", parkId)
        ]
    })
    return items.sort((a, b) => a.descricao.trim().localeCompare(b.descricao.trim()))
}

export const getAllProductsByParkId = async ({ estacionamentoId }) => {
    const items = await getAllDocsByParkId({ collection: Collection.PRODUCT, estacionamentoId: estacionamentoId })
    return items.sort((a, b) => a.descricao.trim().localeCompare(b.descricao.trim()))
}

export const getAllProductsByIds = async ({ ids }) => {
    var result = []
    const chunckIds = chunkItemsByQuantity({ items: ids })
    for (const ids of chunckIds) {
        const resultChunk = await getAllDocsByQueries({
            collection: Collection.PRODUCT,
            queries: [
                where(WhereField.ID, 'in', ids)
            ]
        })
        result.push(...resultChunk)
    }
    return result.sort((a, b) => a.descricao.trim().localeCompare(b.descricao.trim()))
}

export const deleteProduct = async ({ id }) => {
    await deleteDoc({ collection: Collection.PRODUCT, id: id })
}

export const getAllCategories = async ({ parkId }) => {
    return await getAllDocsByQueries({
        collection: Collection.PRODUCT_CATEGORIES, queries: [
            where(WhereField.PARKID, "==", parkId)
        ]
    })
}

export const getAllSubCategories = async ({ parkId }) => {
    return await getAllDocsByQueries({
        collection: Collection.PRODUCT_SUB_CATEGORIES, queries: [
            where(WhereField.PARKID, "==", parkId)
        ]
    })
}

export const updateProductById = async ({ id, data }) => {
    await updateDoc({ collection: Collection.PRODUCT, id: id, data: data })
}